exports = module.exports = require("../../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".PhoneNumberConfig_nickNameLabel_2QC4 {\n  margin-right: 20px;\n  margin-bottom: 10px;\n\n  display: inline-block;\n  vertical-align: middle;\n\n  max-width: 230px;\n\n  font-size: 15px;\n\n  color: #787878;\n}\n\n.PhoneNumberConfig_nickNameInput_3dg1 {\n  margin-right: 20px;\n  margin-bottom: 10px;\n\n  display: inline-block;\n}\n\n.PhoneNumberConfig_saveButton_2GdE {\n  margin-bottom: 10px;\n}\n\n.PhoneNumberConfig_nickNameWrapper_2mDk {\n  margin-bottom: 10px;\n}\n\n.PhoneNumberConfig_footer_22_S {\n  margin-top: 20px;\n  padding-top: 20px;\n\n  border-top: 1px solid #e6e6e6;\n}\n", ""]);

// exports
exports.locals = {
	"nickNameLabel": "PhoneNumberConfig_nickNameLabel_2QC4",
	"nickNameInput": "PhoneNumberConfig_nickNameInput_3dg1",
	"saveButton": "PhoneNumberConfig_saveButton_2GdE",
	"nickNameWrapper": "PhoneNumberConfig_nickNameWrapper_2mDk",
	"footer": "PhoneNumberConfig_footer_22_S"
};